export const ESTOQUE_LOCAL_OPTIONS = [
  { id: 'Almoxarifado I  C17', nome: 'Almoxarifado I  C17' },
  { id: 'Almoxarifado II  C17', nome: 'Almoxarifado II  C17' },
  { id: 'Sala Drones', nome: 'Sala Drones' },
  { id: 'Sucata', nome: 'Sucata' },
];
